export class BusinessPlanSection {
    id!: string
    order!: number
    sectionType!: number
    heading!: string
    theme!: string
    content!: string
}
